import React from "react";
import { DropdownItem, DropdownMenu, DropdownToggle, Input, Label, Col, UncontrolledDropdown, Form, Row } from "reactstrap";
import PropTypes from 'prop-types';
import { useFormik } from "formik";
import { useState } from "react";
import { getPrimaryButtonClass } from "helpers/sf_utils";

const EditUsernameDropdown = (props) => {
    const [fieldFirstName, setFieldFirstName] = React.useState(props.first_name);
    const [fieldLastName, setFieldLastName] = React.useState(props.last_name);
    const [isEditable, setIsEditable] = useState(false)
    const [isOpen, setIsOpen] = useState(false)
    const [isMouseDown, setIsMouseDown] = useState(false)

    const handleOnClickClose = () => {
        setIsOpen(false);
    };

    const toggle = () => setIsOpen(!isOpen);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            first_name: fieldFirstName || '',
            last_name: fieldLastName || '',
        },
        onSubmit: (values) => {
            props?.onSaveUsernameClick({
                ...values,
            });
            handleOnClickClose()
        },
    });

    return (
        <React.Fragment>
            <p className="mb-0"
                onMouseEnter={(e) => {
                    setIsEditable(true);
                }}
                onMouseLeave={(e) => {
                    setIsEditable(false);
                }}
            >
                {props?.first_name + ' ' + props?.last_name}
            </p>
            <UncontrolledDropdown isOpen={isOpen}
             onToggle={(event, isOpen) => {
                if(!isMouseDown && isOpen) {
                    toggle()
                } else if (isMouseDown && isOpen) {
                    setIsMouseDown(false);
                }
                else if (!isOpen) {
                    setIsMouseDown(false);
                    setIsOpen(true)
                }}}
             onMouseDown={(e) => setIsMouseDown(true)}
             onMouseUp={(e) => setIsMouseDown(false)}>
                <DropdownToggle
                    href="#"
                    className='nav-link py-0'
                    tag="i"
                    direction="up"
                >
                    <div style={{ width: "40px" }} onMouseEnter={(e) => {
                        setIsEditable(true);
                    }}
                        onMouseLeave={(e) => {
                            setIsEditable(false);
                        }}>
                        {isEditable === true ?
                            <i
                                className="font-size-13 mdi mdi-pencil text-success"
                            /> :
                            <div className="edit-hover-class">
                                <a ><i
                                    className="font-size-13 mdi mdi-pencil text-danger"
                                />
                                </a>
                            </div>
                        }
                    </div>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-start">
                    <DropdownItem className="font-weight-semibold">Name</DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem text>
                        <Form
                            onSubmit={e => {
                                e.preventDefault();
                                validation.handleSubmit()
                                return false
                            }}
                            className='sf-box-w'
                        >
                            <div className="d-flex flex-column">
                                <Row>
                                    <Col className="d-flex align-items-top">
                                        <Col sm='6' className="pe-1">
                                            <Label>First Name</Label>
                                            <Input
                                                type='text'
                                                className="form-control"
                                                name="first_name"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.first_name || ''}
                                            />
                                        </Col>
                                        <Col sm='6' className="ps-1">
                                            <Label>Last Name</Label>
                                            <Input
                                                type='text'
                                                className="form-control"
                                                name="last_name"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.last_name || ''}
                                            />
                                        </Col>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12" lg="12">
                                        <div className="text-end mt-3">
                                            <button
                                                type="submit"
                                                className={`btn ${getPrimaryButtonClass()} ms-2`}
                                                name="submit"
                                                onClick={() => validation.handleSubmit()}
                                            >
                                                Save
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-light ms-2"
                                                onClick={handleOnClickClose}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Form>
                    </DropdownItem>
                </DropdownMenu>
            </UncontrolledDropdown>
        </React.Fragment>
    )
}

EditUsernameDropdown.propTypes = {
    onSave: PropTypes.func,
    onCancel: PropTypes.func,
    onSaveUsernameClick: PropTypes.func
}

export default EditUsernameDropdown